import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap'

// for the recurring pattern of opening a modal then initializing the modal component
// allows it to be done with more type safety
const openModal = <T>(
  modalService: NgbModal,
  Constructor: new () => T,
  options: NgbModalOptions = {},
): T => {
  return modalService.open(Constructor, options).componentInstance as T
}

export default openModal
